// import axios from "axios";
// import React, { useEffect, useRef, useState } from "react";
// import CreatableSelect from "react-select/creatable";
// import { createLead } from "../../../services/admin.services";
// import { useLocation } from "react-router-dom";
// import { setSelectedLead } from "../../../state/reducers/leadSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { updateLeadForm } from "../../../services/lead.services";
// import AbroadCounselingForm from "./AbroadCouncilingForm";
// import CareerCounselingForm from "./CareerCouncilingForm";
// import TestPrepStudentForm from "./TestPrepStudentForm";
// import VisaStudentForm from "./VisaStudentForm";
// import toast from "react-hot-toast";

// function LeadForm({ toggleModal }) {
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const [lead, setLead] = useState({});
//   // const leads = useSelector((state) => state.leads.leads);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const [formData, setFormData] = useState({});

//   const getData = async () => {
//     const id = location.pathname.split("/")[2];
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/lead/api/lead/${id}/`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             // Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const { lead, parent_info, ...rest } = response.data.data;

//       // Extract intake if it exists
//       let intakeMonth = "";
//       let intakeYear = "";

//       if (parent_info?.intake) {
//         const intakeDate = new Date(parent_info.intake);
//         intakeMonth = intakeDate.toLocaleString("default", { month: "long" }); // Extract month as a string (e.g., "January")
//         intakeYear = intakeDate.getFullYear().toString(); // Extract year as string
//       }

//       // Exclude id and parent_id from parent_info
//       const { id: _, parent_id: __, ...filteredParentInfo } = parent_info || {};
//       const { lead_type_info } = response.data.data;

//       if (lead_type_info?.intake) {
//         const intakeDate = new Date(lead_type_info.intake);
//         intakeMonth = intakeDate.toLocaleString("default", {
//           month: "long",
//         });
//         intakeYear = intakeDate.getFullYear().toString();
//       }

//       setFormData({
//         ...rest, // Spread existing lead data
//         ...(lead || {}), // Spread `lead` into `formData`
//         ...filteredParentInfo, // Spread `parent_info` without id and parent_id
//         ...lead_type_info,
//         // subjects_liked: lead?.subjects_liked ? lead.subjects_liked : "", // Convert string to array
//         // subjects_disliked: lead?.subjects_disliked
//         //   ? lead.subjects_disliked
//         //   : "", // Convert string to array
//         // name_test_preparation_required: Array.isArray(
//         //   lead?.name_test_preparation_required
//         // )
//         //   ? lead.name_test_preparation_required
//         //   : [], // Ensure it's always an array
//         intakeMonth, // Store extracted month
//         intakeYear, // Store extracted year
//       });
//     } catch (err) {
//       console.error("Error fetching leads, using fallback:", err);
//     }
//   };

//   "form", formData);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // try {
//     //   const form = await prepareDataForAPI(formData);
//     //   // JSON.stringify(form));
//     //   if (parentLead) {
//     //     const updatedForm = {
//     //       ...form,
//     //       parent_lead: parentLead.id.toString(),
//     //     };
//     //     "updated", updatedForm);
//     //     await createLead(updatedForm);
//     //   } else {
//     //     await createLead(form);
//     //   }
//     //   alert("Lead created successfully!");
//     //   toggleModal();
//     // } catch (error) {
//     //   console.error(
//     //     "Error creating lead:",
//     //     error.response?.data || error.message
//     //   );
//     //   alert("Failed to create lead. Check your input or try again.");
//     // }

//     const updatedData = {
//       ...formData,
//       subjects_disliked: formData.subjects_disliked || "",
//     };

//     try {
//       await axios.patch(
//         `${process.env.REACT_APP_BASE_URL}/lead/api/lead/${formData.encrypted_id}/`,
//         updatedData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             // Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       // const res = await updateLeadForm(formData.id, formData);
//       // res);
//       setIsSubmitted(true);
//       alert("Form Submitted successfully!");
//     } catch (err) {
//       alert("Failed to create lead. Check your input or try again.");
//       err);
//     }
//   };
//   const validateTextLength = (text, maxWords = 500, maxChars = 3000) => {
//     const safeText = typeof text === "string" ? text : String(text || "");
//     const wordCount = safeText.trim().split(/\s+/).length;
//     const charCount = safeText.length;

//     if (wordCount > maxWords)
//       return `Maximum ${maxWords} words allowed. Currently: ${wordCount} words`;
//     if (charCount > maxChars)
//       return `Maximum ${maxChars} characters allowed. Currently: ${charCount} characters`;

//     return null;
//   };

//   const handleFormValidation = (e) => {
//     e.preventDefault();
//     const textFieldsToValidate = [
//       { key: "personal_details", label: "Personal Details" },
//       { key: "other_perfrences", label: "Other Preferences" },
//       { key: "career_choices", label: "Career Choices" },
//       { key: "competitions_participated", label: "Competitions Participated" },
//       {
//         key: "competitionsDetails",
//         label: "Details of Competitions Participated",
//       },
//       { key: "good_at_theory_subjects", label: "Good at Theory Subjects" },
//       {
//         key: "theory_subjects_good_at_details",
//         label: "Theory Subjects Good At (Details)",
//       },
//       {
//         key: "technology_innovation_details",
//         label: "Technology & Innovation Details",
//       },
//       {
//         key: "interest_in_politics_public_service",
//         label: "Interest in Politics & Public Service",
//       },
//       {
//         key: "politics_public_service_reason",
//         label: "Reason for Interest in Politics/Public Service",
//       },
//       {
//         key: "special_requests_info",
//         label: "Special Requests or Information",
//       },
//     ];

//     for (const field of textFieldsToValidate) {
//       if (formData[field.key]) {
//         const error = validateTextLength(formData[field.key]);
//         if (error) {
//           toast.error(`${field.label}: ${error}`);
//           return;
//         }
//       }
//     }

//     const commonRequiredFields = [
//       { key: "name", label: "Name" },
//       { key: "email", label: "Email" },
//       { key: "phone", label: "Mobile Number" },
//       { key: "reference_source", label: "Reference Source" },
//       // { key: "residence_city_state", label: "Residence" },
//       // { key: "current_education", label: "Current Education" },
//       // { key: "previous_education", label: "Previous Education" },
//       // { key: "gpa_percentage", label: "GPA or Percentage" },
//     ];

//     const abroadFields = [
//       ...commonRequiredFields,
//       { key: "residence_city_state", label: "Residence" },
//       { key: "current_education", label: "Current Education" },
//       { key: "previous_education", label: "Previous Education" },
//       { key: "gpa_percentage", label: "GPA or Percentage" },
//       { key: "intended_degree", label: "Intended Degree" },
//       { key: "countries_for_abroad_studies", label: "Intended Countries" },
//       { key: "intakeMonth", label: "Intake Month" },
//       { key: "intakeYear", label: "Intake Year" },
//     ];

//     const careerFields = [
//       ...commonRequiredFields,
//       { key: "current_education", label: "Current Education" },
//       { key: "previous_education", label: "Previous Education" },
//       { key: "gpa_percentage", label: "GPA or Percentage" },
//       { key: "school_college_name", label: "School/College Name" },
//       { key: "subjects_liked", label: "Subjects Liked" },
//       { key: "career_choices", label: "Career Choices" },
//       {
//         key: "plans_to_study_abroad_future",
//         label: "Plans to Study Abroad in Future",
//       },
//       { key: "join_family_business", label: "Join Family Business" },
//       { key: "competitions_participated", label: "Competitions Participated" },
//       { key: "good_at_theory_subjects", label: "Good at Theory Subjects" },
//       {
//         key: "technology_innovation_details",
//         label: "Technology & Innovation Details",
//       },
//       { key: "associated_with_ngo", label: "Associated with NGO" },
//       {
//         key: "interested_in_construction_models",
//         label: "Interest in Construction Models",
//       },
//       {
//         key: "interested_in_fashion_design",
//         label: "Interest in Fashion Design",
//       },
//       {
//         key: "interest_in_politics_public_service",
//         label: "Interest in Politics/Public Service",
//       },
//       { key: "human_friendly", label: "Human Friendly" },
//       {
//         key: "interested_in_food_nutrition",
//         label: "Interest in Food & Nutrition",
//       },
//       {
//         key: "film_related_career_option",
//         label: "Film-related Career Option",
//       },
//       { key: "personal_details", label: "Personal Details" },
//     ];
//     const testPrepFields = [
//       ...commonRequiredFields,
//       {
//         key: "name_test_preparation_required",
//         label: "Name of tests you require coaching",
//       },
//       { key: "exam_date", label: "Exam Date" },
//       {
//         key: "preferred_mode_of_teaching",
//         label: "Preferred Mode of Teaching",
//       },
//       { key: "country", label: "Intended Country" },
//     ];

//     const visaFields = [
//       ...commonRequiredFields,
//       { key: "visa_country_name", label: "Countries for visa" },
//       { key: "residence_city_state", label: "Residence" },
//     ];

//     let requiredFields = [];

//     switch (formData.lead_type) {
//       case "abroad_counseling":
//       case "profile_building":
//         requiredFields = abroadFields;
//         break;
//       case "career_counseling":
//         requiredFields = careerFields;
//         break;
//       case "visa":
//         requiredFields = visaFields;
//         break;
//       case "test_prep":
//         requiredFields = testPrepFields;
//         break;
//       default:
//         requiredFields = commonRequiredFields;
//     }
//     for (const field of requiredFields) {
//       const value = formData[field.key];

//       const isEmptyArray = Array.isArray(value) && value.length === 0;
//       const isEmptyValue =
//         value === null ||
//         value === undefined ||
//         (typeof value === "string" && value.trim() === "") ||
//         isEmptyArray;

//       if (isEmptyValue) {
//         toast.error(`Please fill in the required field: ${field.label}`);
//         return;
//       }
//     }
//     if (
//       formData.lead_type === "abroad_counseling" ||
//       formData.lead_type === "profile_building"
//     ) {
//       if (formData.gpa_percentage === "percentage" && !formData.percentage) {
//         toast.error("Please enter your percentage.");
//         return;
//       }

//       if (
//         formData.gpa_percentage === "gpa" &&
//         (!formData.gpa || !formData.out_off)
//       ) {
//         toast.error("Please enter your GPA and the scale (e.g., out of 10).");
//         return;
//       }

//       if (
//         !formData.countries_for_abroad_studies ||
//         formData.countries_for_abroad_studies.length === 0
//       ) {
//         toast.error("Please select at least one intended country.");
//         return;
//       }
//     }

//     handleSubmit(e);
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   return (
//     <div className="">
//       {formData.lead_type === "abroad_counseling" && (
//         <AbroadCounselingForm
//           formData={formData}
//           setFormData={setFormData}
//           handleSubmit={handleFormValidation}
//           isSubmitted={isSubmitted}
//         />
//       )}
//       {formData.lead_type === "career_counseling" && (
//         <CareerCounselingForm
//           formData={formData}
//           setFormData={setFormData}
//           handleSubmit={handleFormValidation}
//           isSubmitted={isSubmitted}
//         />
//       )}
//       {formData.lead_type === "test_prep" && (
//         <TestPrepStudentForm
//           formData={formData}
//           setFormData={setFormData}
//           handleSubmit={handleFormValidation}
//           isSubmitted={isSubmitted}
//         />
//       )}
//       {formData.lead_type === "visa" && (
//         <VisaStudentForm
//           formData={formData}
//           setFormData={setFormData}
//           handleSubmit={handleFormValidation}
//           isSubmitted={isSubmitted}
//         />
//       )}
//       {formData.lead_type === "profile_building" && (
//         <AbroadCounselingForm
//           formData={formData}
//           setFormData={setFormData}
//           handleSubmit={handleFormValidation}
//           isSubmitted={isSubmitted}
//         />
//       )}
//     </div>
//   );
// }

// export default LeadForm;
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSelectedLead } from "../../../state/reducers/leadSlice";
// import AbroadCounselingForm from "./AbroadCounselingForm";
// import CareerCounselingForm from "./CareerCounselingForm";
// import TestPrepStudentForm from "./TestPrepStudentForm";
import AbroadCounselingForm from "./AbroadCouncilingForm";
import CareerCounselingForm from "./CareerCouncilingForm";
import TestPrepStudentForm from "./TestPrepStudentForm";
import VisaStudentForm from "./VisaStudentForm";
import SubjectSelectionForm from "./SubjectSelectionForm";
import OthersForm from "./OthersForm";
import { Loader2, AlertCircle } from "lucide-react";
import logo from "../../../assets/Aara_logo.png";

function LeadForm() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const getData = async () => {
    setIsLoading(true);
    const id = location.pathname.split("/")[2];
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/lead/api/lead/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const { lead, parent_info, ...rest } = response.data.data;

      // Extract intake if it exists
      let intakeMonth = "";
      let intakeYear = "";

      if (parent_info?.intake) {
        const intakeDate = new Date(parent_info.intake);
        intakeMonth = intakeDate.toLocaleString("default", { month: "long" }); // Extract month as a string (e.g., "January")
        intakeYear = intakeDate.getFullYear().toString(); // Extract year as string
      }

      // Exclude id and parent_id from parent_info
      const { id: _, parent_id: __, ...filteredParentInfo } = parent_info || {};
      const { lead_type_info } = response.data.data;

      if (lead_type_info?.intake) {
        const intakeDate = new Date(lead_type_info.intake);
        intakeMonth = intakeDate.toLocaleString("default", {
          month: "long",
        });
        intakeYear = intakeDate.getFullYear().toString();
      }

      setFormData({
        ...rest, // Spread existing lead data
        ...(lead || {}), // Spread `lead` into `formData`
        ...filteredParentInfo, // Spread `parent_info` without id and parent_id
        ...lead_type_info,
        // subjects_liked: lead?.subjects_liked ? lead.subjects_liked : "", // Convert string to array
        // subjects_disliked: lead?.subjects_disliked
        //   ? lead.subjects_disliked
        //   : "", // Convert string to array
        // name_test_preparation_required: Array.isArray(
        //   lead?.name_test_preparation_required
        // )
        //   ? lead.name_test_preparation_required
        //   : [], // Ensure it's always an array
        intakeMonth, // Store extracted month
        intakeYear, // Store extracted year
      });
    } catch (err) {
      console.error("Error fetching leads, using fallback:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const { lead_type_info, ...cleanedFormData } = formData;
    const updatedData = {
      ...cleanedFormData,
      personal_details: (cleanedFormData.personal_details || "").trim(),
    };

    try {
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/lead/api/lead/${formData.encrypted_id}/`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setIsSubmitted(true);
      // Store the lead in Redux if needed
      dispatch(setSelectedLead(updatedData));
    } catch (err) {
      setError(
        "Failed to submit form. Please check your information and try again."
      );
      console.error("Submission error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading && !isSubmitted) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="p-8 bg-white rounded-xl shadow-md flex flex-col items-center">
          <img src={logo} alt="Aara Consultancy Logo" className="h-16 mb-6" />
          <Loader2 className="h-12 w-12 text-red-500 animate-spin mb-4" />
          <h2 className="text-xl font-semibold text-gray-800">
            Loading your information...
          </h2>
          <p className="text-gray-500 mt-2">
            Please wait while we prepare your form.
          </p>
        </div>
      </div>
    );
  }

  if (error && !isSubmitted) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="p-8 bg-white rounded-xl shadow-md max-w-md">
          <div className="flex flex-col items-center">
            <img src={logo} alt="Aara Consultancy Logo" className="h-16 mb-6" />
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mb-4">
              <AlertCircle className="h-8 w-8 text-red-500" />
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2 text-center">
              Error Loading Form
            </h2>
            <p className="text-gray-600 text-center mb-6">{error}</p>
            <button
              onClick={() => getData()}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  const renderForm = () => {
    switch (formData.lead_type) {
      case "abroad_counseling":
        return (
          <AbroadCounselingForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      case "profile_building":
        return (
          <AbroadCounselingForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      case "career_counseling":
        return (
          <CareerCounselingForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      case "test_prep":
        return (
          <TestPrepStudentForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      case "visa":
        return (
          <VisaStudentForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      case "subject_selection":
        return (
          <SubjectSelectionForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      case "others":
        return (
          <OthersForm
            formData={formData}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        );
      default:
        return (
          <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
            <div className="p-8 bg-white rounded-xl shadow-md max-w-md text-center">
              <img
                src={logo}
                alt="Aara Consultancy Logo"
                className="h-16 mx-auto mb-6"
              />
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Form Type Not Found
              </h2>
              <p className="text-gray-600 mb-6">
                We couldn't determine the type of form you need. Please contact
                support for assistance.
              </p>
              <p className="text-sm text-gray-500">
                Received form type: {formData.lead_type || "None"}
              </p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">{renderForm()}</div>
  );
}

export default LeadForm;
